<template>
  <div>
    <div class="d-flex justify-content-center mb-3">
      <b-spinner
        style="width: 3rem; height: 3rem"
        label="Large Spinner"
      ></b-spinner>
    </div>
    <div class="d-flex justify-content-center mb-3">
      <strong>{{textLoading}}...</strong>
    </div>
  </div>
</template>
<script>

import {mapState, mapMutations} from 'vuex';
export default {
  computed:{
    ...mapState('loading', [
      'textLoading'
    ])
  }
};
</script>
